/**
 * Niepelna ocena brzmienia: serwer dopisuje do `healthFlags` sesji znacznik
 * `EXPRESSION_PARTIAL:<nieudane>/<ocenianych>` (np. `EXPRESSION_PARTIAL:7/20`), gdy czesc wywolan modelu
 * brzmienia zawiodla. Bez tego raport wygladal tak, jakby brakujacych ocen nigdy nie bylo.
 *
 * healthFlags to lista rozdzielona przecinkami. Parser zna tylko ten jeden znacznik i odrzuca wszystko, co
 * nie ma dokladnie tego ksztaltu (zla liczba, nieudane > ocenianych, zero) zamiast zgadywac.
 */
export interface NiepelnaOcenaBrzmienia {
  nieudane: number;
  ocenianych: number;
}

const ZNACZNIK = /^EXPRESSION_PARTIAL:(\d{1,9})\/(\d{1,9})$/;

export function odczytajNiepelnaOceneBrzmienia(healthFlags: string | null | undefined): NiepelnaOcenaBrzmienia | null {
  if (!healthFlags) return null;
  for (const flaga of healthFlags.split(",")) {
    const m = ZNACZNIK.exec(flaga.trim());
    if (!m) continue;
    const nieudane = Number(m[1]);
    const ocenianych = Number(m[2]);
    if (nieudane >= 1 && ocenianych >= nieudane) return { nieudane, ocenianych };
  }
  return null;
}

/** Zdanie dla uzytkownika: ile wypowiedzi nie dostalo oceny brzmienia i co to znaczy dla raportu. */
export function opisNiepelnejOcenyBrzmienia(o: NiepelnaOcenaBrzmienia): string {
  return (
    `Nie udało się ocenić brzmienia ${o.nieudane} z ${o.ocenianych} wypowiedzi: model nie zwrócił oceny. ` +
    "Te wypowiedzi nie mają oceny brzmienia, a pomiar z sygnału (tempo, ton, pauzy) jest policzony normalnie."
  );
}
